import { ConnectionStatusToName } from '@/src/modules/connections/components/MirrorRegistryStatusBadge/constants';
import { MirrorRegistryStatusIconMap } from '@/src/modules/connections/components/MirrorRegistryStatusBadge/MirrorRegistryStatusIcon';
import type { ApiMirrorRegistryStatus } from '@fabric-app/types/connections';
import { StatusBadge } from '@fabric-app/ui/components/StatusBadge/StatusBadge';
import React from 'react';

const MirrorRegistryStatusSymbol: Record<
  ApiMirrorRegistryStatus,
  React.FC<{ style?: React.CSSProperties }>
> = {
  active: StatusBadge.Dot,
  paused: StatusBadge.Dot,
  initializing: StatusBadge.Dot,
  retrying: StatusBadge.Dot,
  failed: MirrorRegistryStatusIconMap['failed'],
};

export interface MirrorRegistryStatusBadgeProps {
  className?: string;
  status: ApiMirrorRegistryStatus;
  style?: React.CSSProperties;
}

const MIRROR_STATUS_TO_COLOR: Record<ApiMirrorRegistryStatus, 'green' | 'red' | 'orange' | 'grey'> =
  {
    active: 'green',
    paused: 'grey',
    initializing: 'green',
    retrying: 'orange',
    failed: 'red',
  };

export const MirrorRegistryStatusBadge = React.forwardRef<
  HTMLDivElement,
  MirrorRegistryStatusBadgeProps
>(function badge({ className, status, style }, ref) {
  const Symbol = MirrorRegistryStatusSymbol[status];
  return (
    <StatusBadge.Root
      status={MIRROR_STATUS_TO_COLOR[status]}
      className={className}
      style={style}
      ref={ref}
    >
      <Symbol style={{ fontSize: '1.125rem' }} />
      <StatusBadge.Text>{ConnectionStatusToName[status]}</StatusBadge.Text>
    </StatusBadge.Root>
  );
});
